/**
 * Build the set of stop IDs that should be highlighted on the map.
 *
 * Group entry (any type): all group stops highlight.
 * OPTIONS group scrolling: all group stops stay highlighted.
 * SEQUENTIAL group scrolling: individual stop highlights (once activeItemId
 *   is a group stop, we know the user is scrolling within).
 * After leaving an OPTIONS group: stale highlights suppressed.
 */
export function buildActiveMarkerIds(
  activeItemId: string | null,
  activeGroupStopIds: Set<string>,
  allOptionsGroupStopIds: Set<string>,
  isOptionsGroup: boolean,
): Set<string> {
  if (activeGroupStopIds.size > 0) {
    if (isOptionsGroup) {
      // OPTIONS: all group stops always highlighted
      return activeGroupStopIds;
    }
    // SEQUENTIAL: all highlighted on entry, individual once scrolling within
    if (activeItemId && activeGroupStopIds.has(activeItemId)) {
      return new Set([activeItemId]);
    }
    return activeGroupStopIds;
  }
  if (activeItemId && !allOptionsGroupStopIds.has(activeItemId)) {
    return new Set([activeItemId]);
  }
  return new Set();
}
